import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/** Styling for the audited Customer Success specialist change dialog on the Account Overview. */
export const specialistChangeJustificationDialogStyles = StyleSheet.create({
	dialogContent: {
		maxWidth: 560,
		maxHeight: '90vh',
		overflow: 'auto',
	},
	dialogBody: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	warningBanner: {
		display: 'flex',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.sm,
		backgroundColor: THEME.colors.danger.light,
		border: `1px solid ${THEME.colors.danger.main}`,
		borderRadius: THEME.common.borderRadius,
	},
	warningIconWrap: {
		flexShrink: 0,
		width: 36,
		height: 36,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
	warningTitle: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.danger.dark,
		marginBottom: THEME.spacing.xs,
	},
	warningBody: {
		fontSize: THEME.typography.fontSizes.xs,
		lineHeight: 1.5,
		color: THEME.colors.text.main,
	},
	contextLine: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.main,
	},
	fieldGroup: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	label: {
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	changeLine: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
	},
	characterCount: {
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		marginTop: THEME.spacing.xs,
		alignSelf: 'flex-end',
	},
	characterCountOver: {
		color: THEME.colors.danger.dark,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	errorMessage: {
		padding: THEME.spacing.sm,
		backgroundColor: THEME.colors.danger.light,
		border: `1px solid ${THEME.colors.danger.main}`,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.danger.dark,
		fontSize: THEME.typography.fontSizes.sm,
	},
});
